import React, { FunctionComponent } from 'react'
import { Grid, Text } from '@afterpaytouch/core'
import { Trans } from 'next-i18next'
import { useSignUpTerms, useTermsKey } from './hooks'

export const Disclaimer: FunctionComponent = () => {
  const signUpTerms = useSignUpTerms()
  const termsKey = useTermsKey()

  return (
    <Grid>
      <Text color='Gray40' size='XXS' fontFace='CashSansMono'>
        <Trans i18nKey={termsKey} components={signUpTerms} />
      </Text>
    </Grid>
  )
}
